import React from 'react';
import TopSectionBar from '../common/TopSectionBar.js';
import BottomMenuBar from '../common/BottomMenuBar.js';
import '../../styles/ExerciseLayout.css';

const ExamLayout = ({
  sectionTitle,
  timeLeft,
  children,
  onPrev,
  onNext,
  onShowHint,
  isPrevDisabled,
  isNextDisabled,
  mainClassName
}) => {

  const sectionType = sectionTitle.toLowerCase().includes('listening') ? 'Listening' : 'Reading & Writing';

  return (
    <div className="exam-layout">
      <TopSectionBar sectionTitle={sectionTitle} timeLeft={timeLeft} sectionType={sectionType} />

      <main className={`exam-layout-main ${mainClassName || ''}`}>
        {children}
      </main>

      <div className="exam-layout-spacer"></div>

      <BottomMenuBar
        onPrev={onPrev}
        onNext={onNext}
        onShowHint={onShowHint}
        isPrevDisabled={isPrevDisabled}
        isNextDisabled={isNextDisabled}
      />
    </div>
  );
};

export default ExamLayout;
